import { useEffect } from "react";
import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ChevronLeft, ChevronDown, LogOut } from "lucide-react";
import { handleClickOutside } from "./../functions/handleClickOutside";
import { useMenuList } from "./../CustomHooks/useMenuList";
import LogoutAction from "../components/auth/LogoutAction";

const SideBar = ({ openSidebar, setOpenSidebar }) => {
  const menuList = useMenuList();
  const [open, setOpen] = useState(-1);
  const location = useLocation();
  const currentUrl = location.pathname;

  const isCurrentRoute = (subMenu) => {
    if (subMenu && open === -1) {
      return subMenu.some((subItem) => subItem.route === currentUrl);
    } else {
      return false;
    }
  };
  const handleSidebar = () => {
    setOpen(-1);
    setOpenSidebar(false);
  };
  const handleDropdown = (ind, isMenuLink) => {
    setOpen((prevIndex) => (prevIndex === ind ? -1 : ind));
    if (window.innerWidth === 999 && isMenuLink) {
      handleSidebar();
    }
  };
  const handleMenu = () => {
    setOpenSidebar(false);
  };
  useEffect(() => {
    handleClickOutside([openSidebar, setOpenSidebar]);
  }, [setOpenSidebar, openSidebar]);

  return (
    <>
      <div className={`sidebar-main-1 ${openSidebar ? "sidebar-main-2" : ""}`}>
        <div
          className={`modal-content sidebar-wrap ${
            openSidebar ? "max-md:left-0" : "max-md:-left-[400px]"
          }`}
        >
          <div className="sidebar-logo-wrap">
            <Link to="/">
              <img src="/logo.svg" alt="logo" className="sidebar-logo" />
            </Link>
            <ChevronLeft
              color="#021472"
              size={30}
              className="md:hidden"
              onClick={handleSidebar}
            />
          </div>
          <div className="menu-wrap">
            {menuList.map((menu, index) => {
              if (menu.isPerm) {
                return (
                  <div key={index}>
                    <Link
                      onClick={() => handleDropdown(index, menu.route)}
                      className={`main-menu ${
                        menu.route === currentUrl ? "bg-[#9ca3af66]" : ""
                      }`}
                      to={menu.route && menu.route}
                    >
                      {menu.lucideIcon ? (
                        <menu.lucideIcon strokeWidth={1} className="menu-ico" />
                      ) : (
                        <img
                          src={menu.menuIcon}
                          alt="menuIcon"
                          className="menu-ico"
                        />
                      )}
                      <span className="pl-2">{menu.menuTitle}</span>
                      {menu.subMenu && (
                        <ChevronDown
                          color="white"
                          size={20}
                          className={`menu-arr ${
                            open === index || isCurrentRoute(menu.subMenu)
                              ? "rotate-180"
                              : ""
                          } `}
                          alt="arrow"
                        />
                      )}
                    </Link>
                    {menu.subMenu && (
                      <ul
                        className={`subMenu--ul ${
                          open === index || isCurrentRoute(menu.subMenu)
                            ? `ease-in ${menu.height} visible py-1 lg:py-3`
                            : "ease-out h-0 invisible"
                        } `}
                      >
                        {menu.subMenu.map((submenu, ind) => {
                          if (submenu.isPerm) {
                            return (
                              <li key={ind} onClick={handleMenu}>
                                <Link
                                  className={`subMenu-link ${
                                    currentUrl === submenu.route ? "bg-lb3" : ""
                                  }`}
                                  to={submenu.route && submenu.route}
                                >
                                  {submenu.lucideIcon ? (
                                    <submenu.lucideIcon
                                      strokeWidth={1}
                                      size={22}
                                      className="absolute left-5 menu-ico"
                                    />
                                  ) : (
                                    <img
                                      src={submenu.menuIcon}
                                      alt="submenuIcon"
                                      className="menu-ico absolute left-5"
                                    />
                                  )}
                                  <span className="inline-block pl-5">
                                    {submenu.menuTitle}
                                  </span>
                                </Link>
                              </li>
                            );
                          }
                          return null;
                        })}
                      </ul>
                    )}
                  </div>
                );
              }
              return null;
            })}
            <LogoutAction>
              {({ onLogout, loading }) => (
                <button
                  onClick={onLogout}
                  className="main-menu w-full"
                  disabled={loading}
                >
                  <LogOut strokeWidth={1} size={16} />
                  <span className="pl-2">
                    {loading ? "Logging out..." : "Logout"}
                  </span>
                </button>
              )}
            </LogoutAction>
          </div>
        </div>
      </div>
    </>
  );
};
export default SideBar;
